import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from '../../store';

import { isInteger } from '../../common/common';
import LineInp from '../common/input';
import Radio from '../common/radio';
import ComDetails from '../comDetails/ComDetails';
import { saveEditDetails, toggleFinalSave } from '../../actions/editPolicy-actions';

class PassDetails extends Component {
    constructor(props){
        super(props);
        this.state = {
            PaxDetail:[],
            comDetails:false,
            passDetails:true,
            editOptions:[]
        };
    }

    componentDidMount() {
        this.setState({editOptions:this.props.editPolicy.editOptions})

        let PaxDetail;
        if(this.props.editPolicy.editDetails.PaxDetail){
            PaxDetail = this.props.editPolicy.editDetails.PaxDetail;
        }else{
            let APIGetBookingDetailsResult = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
            PaxDetail = APIGetBookingDetailsResult.PaxDetail; 
        }
        this.setState({PaxDetail:PaxDetail})
    }

    handleChanges = (e,index) => {
        var tmpstate = this.state.PaxDetail;
        tmpstate[index].PaxName = e.target.value;
        this.setState({PaxDetail:tmpstate});
    }

    handleAgeChanges = (e,index) => {
        var tmpstate = this.state.PaxDetail;
        tmpstate[index].Age = e.target.value;
        this.setState({PaxDetail:tmpstate});
    }

    handleGenderChanges = (e,index) => {
        var tmpstate = this.state.PaxDetail;
        e.target.value === 'Male' ? tmpstate[index].Gender = 'M' : tmpstate[index].Gender = 'F';
        this.setState({PaxDetail:tmpstate});
    }

    closeSlider = (name,value) => {
        this.setState({[name]:value});
    }

    passDetails = () => {
        let loop = this.state.PaxDetail;
        let allowEdit = this.props.editPolicy.filter;
        return(
            <div>
                <div className='top-wrapper' style={{background: window.color['searchBoxBgColor']}}>
                    <span className='back-arrow' onClick = { () => {this.props.closeSlider('passDetails',false); store.dispatch(toggleFinalSave(false)) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                            <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"/>
                        </svg>
                    </span>
                    <span className='header-title'>
                        Passenger Detail
                    </span>
                </div>
                <div className='ep-wrapper' style={{zIndex:'8',height:'calc(100% - 110px)'}}>
                    { loop.map((el, index) => {
                        return(
                            <div key={index}>
                                Seat: { el.SeatNo }
                                <div className='passDetails-wrapper' key = { index } style={{marginTop:'10px'}}>
                                    {  allowEdit.IsPaxNameEdit && 
                                        <LineInp
                                            type = 'text'
                                            placeholder = 'Enter Name'
                                            name = { 'paxName[' + index + ']' }
                                            style = {{ width: '100%'}}
                                            value = { el.PaxName }
                                            handleChange = { (e) => {(/^[a-zA-Z ]+$/.test(e.target.value) || !e.target.value) && this.handleChanges(e,index)  } }
                                        />
                                    }
                                    {  allowEdit.IsPaxAgeEdit &&
                                        <LineInp
                                            type = 'tel'
                                            placeholder = 'Enter Age'
                                            name = { 'paxAge[' + index + ']' }
                                            style = {{ width: '100%'}}
                                            max = { 2 }
                                            value = { el.Age }
                                            handleChange = { (e) => { (isInteger(parseInt(e.target.value, 10)) || !e.target.value) && this.handleAgeChanges(e,index)  }}
                                        />
                                    }
                                    {  allowEdit.IsPaxGenderEdit &&
                                        <div style = {{
                                                width: 'calc(100% - 20px)',
                                                display: 'flex',
                                                justifyContent: 'space-around',
                                                padding: '15px 0'
                                            }}> Gender
                                            <Radio
                                                value = 'Male'
                                                showValue = 'Male'
                                                name = { 'paxGender[' + index + ']' }
                                                index = { index }
                                                checked = { el.Gender === 'M' }
                                                handleChange = { (e) => this.handleGenderChanges(e,index) }
                                            />
                                            <Radio
                                                value = 'Female'
                                                showValue = 'Female'
                                                name = { 'paxGender[' + index + ']' }
                                                index = { index }
                                                checked = { el.Gender === 'F' }
                                                handleChange = { (e) => this.handleGenderChanges(e,index) }
                                            />
                                        </div>
                                    }
                                    <div style={{position:'fixed',left:'0',bottom:'0',background: '#fff',width:'100%',fontSize:'.85rem',boxShadow:'0 -1px 2px 1px #ddd'}}>
                                        <div style={{display:'flex',padding: '20px'}}>
                                            <div className='btn1' style={{background: '#fff',color:'#444',border:'1px solid #d7d7d7',marginRight:'10px'}} onClick={()=>this.routechange()}>Cancel</div>
                                            <div className='btn1' style={{
                                                background: el.PaxName && el.Age ? window.color['buttonColor'] : '#ddd',
                                                color:'#fff'}} 
                                                onClick={()=>el.PaxName && el.Age ? this.checkEditOption():''}>PROCEED</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }) }
                </div>
            </div>
        )
    }

    checkEditOption = () => {
        let editDetails = this.props.editPolicy.editDetails;
        editDetails['PaxDetail'] = this.state.PaxDetail;
        store.dispatch(saveEditDetails(editDetails));

        const editOptions = this.props.editPolicy.editOptions;
        let flag =0;
        for (var i = 0; i < editOptions.length; i++) {
            let el = editOptions[i];
            if(el.value === 'on' && el.name !== 'seatChart' && el.name !== 'pickUp' && el.name !== 'dropOff' && el.name !== 'passDetails') {
                this.setState({ [el.name]:true});
                flag =1;
                break;
            }
        }
        if(flag === 0) {
            store.dispatch(toggleFinalSave(true)); 
        }
    }

	render() {
    	return (
            <div>
                {this.state.passDetails && this.passDetails()}
                {this.state.comDetails && <ComDetails closeSlider = {(a,b) => this.closeSlider(a,b)} /> }
            </div>
    	);
  	}
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(PassDetails);


// WEBPACK FOOTER //
// ./src/components/passDetails/PassDetails.js